import { render, staticRenderFns } from "./Spedy.vue?vue&type=template&id=6a11acd5&scoped=true&"
import script from "./Spedy.vue?vue&type=script&lang=js&"
export * from "./Spedy.vue?vue&type=script&lang=js&"
import style0 from "./Spedy.vue?vue&type=style&index=0&id=6a11acd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a11acd5",
  null
  
)

export default component.exports